/**
 * 
 * key
 * 
 */


const key = 'dmlkZW9UZWFtUHJvZHVjdGl2aXR5UmVwb3J0'

export default key 